<div class="lock-settings-fields-container">
  <div
    class="loading-BloWorkshop"
    *ngIf="
      (!loadBloqued && pagingTypeLocks !== 'historial') ||
      (pagingTypeLocks === 'historial' && isHistoryLoading)
    "
  >
   
    <section>
      <div  class="pulsing">
        <mat-spinner [diameter]="50" ></mat-spinner>
      </div>
      <p class="pulsing">{{"Loading" | translate }}</p>
    </section>
  </div>
</div>

<div class="dialog-container">
  <div class="dialog-icon-container">
    <!-- <i *ngIf="initialpage" class="bi bi-x-lg"></i> -->
    <img
      src="../../../../../assets/close-icon.png"
      alt="close-icon"
      class="close-icon"
      *ngIf="initialpage"
      (click)="onCancel()"
    />
    <h1 mat-dialog-title>
      <span *ngIf="initialpage"> {{"LockManagement" | translate }}</span>
      <span *ngIf="pagingTypeLocks === 'blocks'">
        {{"ConfigurationExceptionsWorkshop" | translate }}
      </span>
      <span *ngIf="pagingTypeLocks === 'historial'"
        >{{"BloquedHistory" | translate }}</span
      >
    </h1>
  </div>

  <div class="row ButtonsHeader" *ngIf="initialpage">
    <mat-label>{{"SelectOptionblock" | translate }}</mat-label>

    <button
      class="col-lg-12 matbutton2"
      mat-button
      (click)="ButtonTypeconfigOrHistorial('blocks')"
    >
      {{"ConfigurationExceptionsWorkshop" | translate }}
    </button>

    <button
      class="col-lg-12 matbutton1"
      mat-button
      (click)="ButtonTypeconfigOrHistorial('historial')"
    >
      {{"BloquedHistory" | translate }}
    </button>
  </div>

 

  <div
    *ngIf="pagingTypeLocks === 'blocks' "
    mat-dialog-content
    class="lock-settings-fields-container"
  >
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-12">
            <p class="fields-header">{{"LockByDateTime" | translate }}</p>
          </div>
        </div>

        <mat-label>{{"SelectTheDateForTheBlock" | translate }}</mat-label>
        <div class="row">
          <div class="col-lg-4">
            <mat-form-field>
              <mat-label class="datepicker-label" id="activarOrdenes"
                >{{"StartDate" | translate }}</mat-label
              >
              <input
                matInput
                [matDatepicker]="fromPicker"
                [(ngModel)]="StartDate"
                [matDatepickerFilter]="dateFilter"
                (ngModelChange)="ChangeDateEnd()"
              />
              <mat-datepicker-toggle matPrefix [for]="fromPicker">
                <mat-icon matDatepickerToggleIcon>
                  <div>
                    <img
                      src="../../../../../assets/datepicker-icon.svg"
                      alt="datepicker icon"
                    />
                  </div>
                </mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker
                #fromPicker
                [calendarHeaderComponent]="customDatePickerHeader"
              ></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field>
              <mat-label class="datepicker-label"
                >{{"EndDate" | translate }}</mat-label
              >
              <input
                matInput
                [matDatepicker]="toPicker"
                [(ngModel)]="EndDate"
                [matDatepickerFilter]="dateFilterEnd"
              />
              <mat-datepicker-toggle matPrefix [for]="toPicker">
                <mat-icon matDatepickerToggleIcon>
                  <div>
                    <img
                      src="../../../../../assets/datepicker-icon.svg"
                      alt="datepicker icon"
                    />
                  </div>
                </mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker
                #toPicker
                [calendarHeaderComponent]="customDatePickerHeader"
              ></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <mat-label
          >{{"SelectTheHourorTimeFortheBlocking" | translate }}</mat-label
        >
        <div class="row">
          <div class="col-lg-4">
            <mat-form-field>
              <mat-label
                ><i class="bi bi-clock"></i> {{"StartTime" | translate
                }}</mat-label
              >
              <!-- <input matInput type="time" [(ngModel)]="StartHour" [disabled]="blockDay" > -->
              <mat-select [(ngModel)]="StartHour" [disabled]="blockDay">
                <mat-option
                  *ngFor="let hours of timehours"
                  [value]="hours"
                  [disabled]="blockDay"
                  >{{hours}}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field>
              <mat-label
                ><i class="bi bi-clock"></i> {{"TimeEnd" | translate
                }}</mat-label
              >
              <!-- <input matInput type="time" [(ngModel)]="hourFinal" [disabled]="blockDay"> -->
              <mat-select [(ngModel)]="hourFinal" [disabled]="blockDay">
                <mat-option
                  *ngFor="let hours of timehours"
                  [value]="hours"
                  [disabled]="blockDay"
                  >{{hours}}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-4">
            <mat-checkbox
              class="check-box-color"
              [(ngModel)]="blockDay"
              (click)=" ChangeTypeBlock(blockDay,'Day')"
              >{{"BlockAllDay" | translate }}</mat-checkbox
            >
          </div>
        </div>

        <p *ngIf="ValidationOfCorrectHours()" class="Funcion_horas">
          {{"VerifyHours" | translate }}
        </p>

        <div class="row">
          <div class="col-lg-12">
            <p class="fields-header">{{"BrandLock" | translate }}</p>
          </div>
        </div>
        <mat-label>{{"SelecttheBrandsToBlock" | translate }}</mat-label>
        <div>
          <div class="demo">
            <app-carousel
              [recievedArray]="brands"
              (brand)="onApplyFilter($event)"
            ></app-carousel>
          </div>
        </div>
        <div class="row dialog-footer">
          <div class="col-lg-5">
            <mat-checkbox
              class="check-box-color"
              [(ngModel)]="checkCopiBrandBloqued"
            >
              {{"CopyAllConfigurationBrands" | translate }}
            </mat-checkbox>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <p class="fields-header">
              {{"ActivateDeactiveService" | translate }}
            </p>
          </div>
        </div>

        <mat-label>{{"SelectServiceTypesToBlock" | translate }}</mat-label>
        <div class="wrapper">
          <div *ngFor="let serviceItem of service ; let i=index ">
            <mat-slide-toggle
              *ngIf="serviceItem.serviceName !== ''"
              [(ngModel)]="serviceItem.isActive"
              [disabled]="typeOfServiceCopy"
            >
              {{serviceItem.serviceName | translate}}</mat-slide-toggle
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row dialog-footer">
      <div class="col-lg-5">
        <mat-checkbox
          class="check-box-color"
          [(ngModel)]="typeOfServiceCopy"
          (change)="ChangeTypeofservice()"
        >
          {{"BlockSllTypesOfService" | translate }}
        </mat-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <p class="fields-header">{{"ReasonForBlocking" | translate }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <mat-label class="block-reason"
          >{{"SelectTheReasonForTheBlock" | translate }}</mat-label
        >
      </div>
      <div class="col-lg-4">
        <mat-form-field>
          <mat-label>{{'SelectOption' | translate }}</mat-label>
          <mat-select
            [(ngModel)]="IdbloquingReason"
          >
            <mat-option
              *ngFor="let reasons of reasonAdvisors"
              [value]="reasons.blockedReasonId"
              >{{reasons.reasonName | translate}}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="refreshLoader" class="row dialog-footer">
      <div class="loading-container">
        <section>
          <div  class="pulsing">
            <mat-spinner [diameter]="50" ></mat-spinner>
          </div>
          <p class="pulsing">{{"Searching" | translate }}</p>
        </section>
      </div>
    </div>

    <div class="row dialog-footer">
      <div class="col-lg-12 dialog-controls-container">
        <button class="dialog__button" (click)="onCancel()">
          {{"Cancel" | translate }}
        </button>
        <button
          class="dialog__button dialog__button--fill"
          [disabled]="issaveDisabled()"
          
          (click)="onsave()"
        >
          {{"Accept" | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- implementacion de diseño Historial -->

  <div
    mat-dialog-content
    class="lock-settings-historial-container"
    *ngIf="pagingTypeLocks === 'historial' && !isHistoryLoading"
  >
    <div class="row">
      <div class="col-lg-12">
        <p class="fields-header">
          <strong>{{"Advisor" | translate }}</strong>
          <mat-label> {{advisor.advisorName}} </mat-label>
        </p>
      </div>
    </div>

    <div
      class="card-consultant-check"
      *ngFor="let DataLocks of historialLocks; let i = index"
    >
      <div class="content-card-consultant-check">
        <div class="content-text">
          <div class="content-card-text-consultant-check">
            <div class="item-card-consultant">
              <p>{{"Brand" | translate }}</p>
              <h2>{{ DataLocks.brandName }}</h2>
            </div>
            <div class="item-card-consultant">
              <p>{{"Date" | translate }}</p>
              <h2>
                {{ DataLocks.initialDateBlockedServices}} - {{
                DataLocks.finalDateBlockedServices}}
              </h2>
            </div>
            <div class="item-card-consultant">
              <p>{{"Time" | translate }}</p>
              <h2>
                {{ DataLocks.hourInitialBlockedServices}} - {{
                DataLocks.hourFinalBlockedServices}}
              </h2>
            </div>
            <div class="item-card-consultant">
              <p>{{"Reason" | translate }}</p>
              <h2>{{ DataLocks.reasonName | translate}}</h2>
            </div>
            <div class="item-card-consultant">
              <p>{{"Service" | translate }}</p>
              <h2 *ngFor="let serviceName of DataLocks.serviceNamesArray">
                {{ serviceName | translate }}
              </h2>
            </div>
          </div>
        </div>
        <div class="content-card-consultant-check-btn">
          <button
            mat-raised-button
            class="btn-card-consultant"
            style="background-color: #9e61a4"
            (click)="onDeleteAdvisorClick(DataLocks)"
          >
            <i class="bi bi-trash3" style="color: #fff" matTooltip="Eliminar">
            </i>
            <p>{{"Delete" | translate }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="pagingTypeLocks === 'historial'" class="historial-btn">
    <button class="button-cancel-historial" (click)="onCancel()">
      {{"Cancel" | translate }}
    </button>
  </div>
</div>
